var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.urgencyLabel)?_c('span',{staticClass:"tw-label",class:_vm.urgencyLabel.style},[_vm._v("\n    "+_vm._s(_vm.urgencyLabel.label)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }